export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
    visible: !that.disabled,
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'displayImage',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_fabricColorNo') || '颜色编号',
    field: 'fabricColorNo',
    align: 'left',
    minWidth: 220,
  },
  {
    title: that.$l('table_label_fabricColorTitle') || '面料颜色',
    field: 'fabricColorTitle',
    align: 'left',
    minWidth: 220,
  },
  {
    title: that.$l('table_label_fabricColorTitleEn') || '面料颜色英文',
    field: 'fabricColorTitleEn',
    align: 'left',
    minWidth: 220,
  },
  {
    title: that.$l('table_label_isCustomerExclusiveColor') || '是否客户专属颜色',
    field: 'isCustomerExclusiveColorText',
    align: 'left',
    minWidth: 60,
  },
  {
    title: that.$l('table_label_fabricColorStatus') || '状态',
    field: 'fabricColorStatus',
    align: 'left',
    width: 100,
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  },
]
